// espacioHistoryService.ts
import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const ESPACIO_HISTORY_API_URL = 'espacio-history/';

export const fetchEspacioHistory = async () => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(ESPACIO_HISTORY_API_URL);
        return response.data;
    });
};
